export default __webpack_public_path__ + "static/media/chip.b13c33f4.png";